import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconColorFan16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconColorFan16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 11.5v2a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5m0-1.415a1.5 1.5 0 0 1 .222-.06L5 5.216V3.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5zm1.56-.377 5.396-3.115.915-1.585a.5.5 0 0 0-.183-.683L7.856 3.267a.5.5 0 0 0-.683.183L6 5.483V5.5h-.01zM5.055 10h6.231l1.655-.955a.5.5 0 0 0 .182-.683L12.067 6.53a.5.5 0 0 0-.683-.183zm8.231 0h.214a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 13.5v-10A1.5 1.5 0 0 1 2.5 2h2A1.5 1.5 0 0 1 6 3.483l.307-.533a1.5 1.5 0 0 1 2.05-.549l1.831 1.058a1.5 1.5 0 0 1 .55 2.049l-.05.085.195-.112a1.5 1.5 0 0 1 2.049.549l1.057 1.832a1.5 1.5 0 0 1-.549 2.049z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconColorFan16);
